export default "__VITE_ASSET__Dpnpeb7Y__"